module.exports = __webpack_public_path__ + "static/media/logo.099da00b.svg";